import CheckboxDisabledIcon from './CheckboxDisabledIcon'

export default CheckboxDisabledIcon
